export default {
  webapp: "58d94b0e-2d5b-44f1-afe2-b2c817877304",
  foerderfinder: "c651eb42-3a9a-4523-b67a-3cf849247237"
};
